import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import GenericPickerModal from './GenericPickerModal'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { getProducts } from 'state/actions/ProductActions'
import { SalesOrgIds } from 'state/constants/SalesOrgIds'

/**
 * Modal component for displaying products for selection, with search and filter
 * @param {*} props Props passed into this component
 */
function ProductPickerModal(props) {

  const products = useSelector(state => state.ProductReducer.products)

  const [t, i18n] = useTranslation()
  const dispatch = useDispatch()

  const flavour = process.env.REACT_APP_FLAVOUR

  useEffect(() => {
    dispatch(getProducts(() => { }))
  }, [])

  /**
   * Filter for products by sales organisation
   * @param {*} product Product object
   * @param {*} filter Filter value
   */
  function filterSalesOrgFunction(product, filter) {
    var includeProduct = false
    for (var i = 0; i < product.AvailableToSalesOrg.length; i++) {
      const salesData = product.AvailableToSalesOrg[i]
      if (salesData == filter) {
        if (!includeProduct) {
          includeProduct = true
          break
        }
      }
    }
    return includeProduct
  }

  return (
    <GenericPickerModal
      handleCancel={() => props.setProductModalOpen(false)}
      handleDone={selectedProducts => props.handleProductSelection(selectedProducts)}
      open={props.productModalOpen}
      selected={props.selected}
      currentSelection={props.currentSelection}
      handleSelection={() => { }}
      getAllData={(callback) => dispatch(getProducts(callback))}
      searchTitle={t('product.search-products')}
      title={t('product.products')}
      data={Object.values(products)}
      idField="id"
      valueField="ProductDisplayName"
      secondaryValueField="ProductName"
      secondaryFields={["id"]}
      filterFunction={filterSalesOrgFunction}
      filterLabel={t('product.filter-by-sales-org')}
      filterData={Object.values(SalesOrgIds()[flavour])}
    />
  )
}

ProductPickerModal.propTypes = {
  productModalOpen: PropTypes.bool,
  setProductModalOpen: PropTypes.func,
  handleProductSelection: PropTypes.func,
  selected: PropTypes.array,
  currentSelection: PropTypes.array
}

export default ProductPickerModal

